<template>
  <div id="login">
    <div class="logins">
      <img src="../../public/img/Icon6.png" alt @click="handleHome()" />
      <div class="name">
        <p>username :</p>
        <input type="text" v-model="username" placeholder="Phone Or Email" />
      </div>
      <div class="password">
        <p>password :</p>
        <input type="password" v-model="password" placeholder="password" />
      </div>
      <button class="lg" @click="handleClick()">
        Sign In
        <a-icon type="right" />
      </button>
      <p class="first">NOT REGISTERED?</p>
      <p
        class="last"
      >You must be an existing customer to use the online ordering service. For Patients, please contact your Practitioner to obtain an account.</p>
      <a class="rg">
        <el-button type="text" @click="open">
          Register with Awesome Wholesale
          <a-icon type="right" />
        </el-button>
      </a>
    </div>
  </div>
</template>
<script>
import Axios from 'axios'
import {
  showFooter,
  hideFooter,
  showNavbar,
  hideNavbar
} from '../store/type.js'
export default {
  data () {
    return {
      username: '',
      password: ''
    }
  },
  beforeMount () {
    this.$store.commit(hideFooter)
    this.$store.commit(hideNavbar)
  },

  beforeDestroy () {
    this.$store.commit(showFooter)
    this.$store.commit(showNavbar)
  },
  methods: {
    handleClick () {
      Axios.post(`${this.APi}/api/v1/wholesale/login`, {
        password: this.password,
        account: this.username
      }).then(responses => {
        // 存token
        if (responses.data.code == '200') {
          localStorage.setItem('token', responses.data.result.token)
          localStorage.setItem('ABN', responses.data.result.memberCode)
          this.$router.replace('/goodslist')
        } else {
          swal(responses.data.message, {
            button: false,
            timer: 3000
          })
        }
      })
    },
    handleHome () {
      this.$router.replace('/goodlist')
    },
    open () {
      this.$alert(
        'To become a Awesome member, please send your company details (including company’s name, ABN, contact number) to admin@awesomewarehouse.com.au or contact George +61 043 085 8896 . Our sales representative will contact you in 2 business days.',
        'Please contact us',
        {
          showConfirmButton: false,
          center: true,
          customClass: 'li',
          callback: action => {}
        }
      )
    }
  }
}
</script>
<style>
.el-button{
  width:120%!important;
  margin-left:-56px;
}
.el-message-box {
  width: 800px !important;
}
@media (width: 768px) {
  .el-message-box {
    width: 500px !important;
  }
}
</style>
<style lang="scss" scoped>
#login {
  .logins {
    margin: 0 auto;
    width: 340px;
    cursor: pointer;
    .hh {
      background: #333;
      height: 100%;
      width: 100%;
    }
    p.first {
      margin-bottom: 0;
    }
    p.last {
      margin-bottom: 0;
    }
    .rg {
      display: block;
      border-radius: 0.3125rem;
      margin-left: 1.487rem;
      color: #fff;
      text-align: center;
      user-select: none;
      &:hover {
        opacity: 0.8;
      }
    }
    button {
      border-radius: 0.3125rem;
      width: 100%;
      height: 0.4625rem;
      margin-top: 0.125rem;
      outline: none;
      background: #001c47;
      color: #fff;
      border: 0;
      padding: 0;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
    img {
      width: 100%;
    }
    p {
      margin-bottom: 0;
      margin-bottom: 5px;
      font-weight: 700;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 0.175rem;
      line-height: 1.42857143;
      color: #333;
    }
    input {
      border-radius: 0.3125rem;
      outline: none;
      border: 0;
      width: 100%;
      height: 65%;
      background-color: rgb(232, 240, 254);
      padding: 0.175rem 0.25rem;
      caret-color: #bdcada;
      color: black;
      font-weight: 500;
    }
    input::placeholder {
      color: #bdcada;
      font-weight: 500;
    }
    .name {
      width: 100%;
      height: 0.9375rem;
    }
    .password {
      width: 100%;
      height: 0.9375rem;
    }
  }
}
</style>
